import { Footer, FooterText } from "./footer.styles";

export const FooterComponent = () => {
  return (
    <Footer>
      <FooterText>Reneelouise.tech © 2026</FooterText>
    </Footer>
  );
};
